<template>
  <div class="postal-code">
    <textInput
      class="input-field"
      :disabled="disabled"
      :label="label"
      :placeholder="placeholder"
      :prepend-inner-icon="icon"
      :prefix="prefix"
      ref="input"
      :rules="validationRules"
      :value="value"
      :width="width"
      @beforeinput="handleInput"
      @change="[setConfigValue($event)]"
      validate-on-blur
    >
      <template
        v-if="!hideTooltip && !hideLabel && (!!tooltip || !!helpContent)"
        #append-label
      >
        <tooltip v-if="tooltip" :text="tooltip" />
        <helpIcon v-if="helpContent" :content="helpContent" />
      </template>
    </textInput>
    <template v-if="!hideTooltip && hideLabel && (!!tooltip || !!helpContent)">
      <tooltip v-if="tooltip" :text="tooltip" />
      <helpIcon v-if="helpContent" :content="helpContent" />
    </template>
  </div>
</template>
  
  <script>
/**
 * @fileoverview Config input field for postal codes
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import textInput from "@/qux-common/qux22/components/molecules/input";
import getValidationRules from "@/util/getValidationRules";
import fieldMap from "./field-map.json";

export default {
  name: "PostalCodeField",
  components: { textInput },
  props: {
    category: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    helpContent: {
      type: String,
    },
    hideLabel: {
      type: Boolean,
    },
    hideTooltip: {
      type: Boolean,
    },
    icon: {
      type: String,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    parentField: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    prefix: {
      type: String,
    },
    rules: {
      type: Array,
    },
    tooltip: {
      type: String,
    },
    value: {
      type: [Number, String],
    },
    width: {
      type: String,
    },
  },
  methods: {
    /**
     * Sets the value
     */
    setConfigValue(value) {
      this.$emit("setConfigValue", value);
    },
    handleInput(e) {
      // don't allow non-numeric characters
      const allowedChars = /[0-9]+/;
      if (
        (e.inputType === "insertText" || e.inputType === "insertFromPaste") &&
        !allowedChars.test(e.data)
      ) {
        e.preventDefault();
      }
    },
    getFieldValue(value) {
      return (
        fieldMap[this.category] &&
        fieldMap[this.category][this.id] &&
        fieldMap[this.category][this.id][value]
      );
    },
    validate() {
      return this.$refs.input.validate();
    },
  },
  computed: {
    validationRules() {
      return getValidationRules({
        rules: this.rules,
        inputErrorMessage: this.getFieldValue("inputErrorMessage"),
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.postal-code {
  display: flex;
  gap: $qvo-spacing-8;
  .input-field {
    width: 100%;
  }
}
</style>